/**
 * Lead Status Enum
 * Represents the current status of a lead
 */
export const LEAD_STATUS = {
  NEW: 'NEW',
  ASSIGNED: 'ASSIGNED',
  IN_PROCESS: 'IN_PROCESS',
  CONVERTED: 'CONVERTED',
  CLOSED: 'CLOSED',
  DELETED: 'DELETED',
}

/**
 * Lead Status Labels (Ukrainian)
 */
export const LEAD_STATUS_LABELS = {
  [LEAD_STATUS.NEW]: 'Новий',
  [LEAD_STATUS.ASSIGNED]: 'Призначено',
  [LEAD_STATUS.IN_PROCESS]: 'В роботі',
  [LEAD_STATUS.CONVERTED]: 'Конвертовано',
  [LEAD_STATUS.CLOSED]: 'Закрито',
  [LEAD_STATUS.DELETED]: 'Видалено',
}

/**
 * Lead Status Colors for badges
 */
export const LEAD_STATUS_COLORS = {
  [LEAD_STATUS.NEW]: 'blue',
  [LEAD_STATUS.ASSIGNED]: 'cyan',
  [LEAD_STATUS.IN_PROCESS]: 'purple',
  [LEAD_STATUS.CONVERTED]: 'green',
  [LEAD_STATUS.CLOSED]: 'gray',
  [LEAD_STATUS.DELETED]: 'red',
}

/**
 * Lead State Enum
 */
export const LEAD_STATE = {
  NEW: 'new',
  QUALIFYING: 'qualifying',
  OFFER_WRITE: 'offer_write',
  OFFER_SENT: 'offer_sent',
  WAITING_CLIENT: 'waiting_client',
  NEGOTIATION: 'negotiation',
  DEAL_PAYMENT: 'deal_payment',
  WON: 'won',
  LOST: 'lost',
  DEAD: 'dead',
  FORGIVEN: 'forgiven',
  SLEEPING: 'sleeping',
}

/**
 * Lead State Labels (Ukrainian)
 */
export const LEAD_STATE_LABELS = {
  [LEAD_STATE.NEW]: 'Новий',
  [LEAD_STATE.QUALIFYING]: 'Кваліфікація',
  [LEAD_STATE.OFFER_WRITE]: 'Написання пропозиції',
  [LEAD_STATE.OFFER_SENT]: 'Пропозицію надіслано',
  [LEAD_STATE.WAITING_CLIENT]: 'Очікування клієнта',
  [LEAD_STATE.NEGOTIATION]: 'Переговори',
  [LEAD_STATE.DEAL_PAYMENT]: 'Оплата угоди',
  [LEAD_STATE.WON]: 'Виграно',
  [LEAD_STATE.LOST]: 'Програно',
  [LEAD_STATE.DEAD]: 'Мертвий',
  [LEAD_STATE.FORGIVEN]: 'Прощено',
  [LEAD_STATE.SLEEPING]: 'Сплячий',
}

/**
 * Lead Source Enum
 */
export const LEAD_SOURCE = {
  CALL: 'CALL',
  EMAIL: 'EMAIL',
  WEBSITE: 'WEBSITE',
  SOCIAL: 'SOCIAL',
  MESSENGER: 'MESSENGER',
  CUSTOMER: 'CUSTOMER',
  PARTNER: 'PARTNER',
  PUBLIC_REL: 'PUBLIC_REL',
  CAMPAIGN: 'CAMPAIGN',
  TELEGRAM_ASSISTANT: 'TELEGRAM_ASSISTANT',
  OTHER: 'OTHER',
}

/**
 * Lead Source Labels (Ukrainian)
 */
export const LEAD_SOURCE_LABELS = {
  [LEAD_SOURCE.CALL]: 'Телефонний дзвінок',
  [LEAD_SOURCE.EMAIL]: 'Email',
  [LEAD_SOURCE.WEBSITE]: 'Веб-сайт',
  [LEAD_SOURCE.SOCIAL]: 'Соц. мережі',
  [LEAD_SOURCE.MESSENGER]: 'Месенджер',
  [LEAD_SOURCE.CUSTOMER]: 'Клієнт',
  [LEAD_SOURCE.PARTNER]: 'Партнер',
  [LEAD_SOURCE.PUBLIC_REL]: 'PR',
  [LEAD_SOURCE.CAMPAIGN]: 'Кампанія',
  [LEAD_SOURCE.TELEGRAM_ASSISTANT]: 'Telegram бот',
  [LEAD_SOURCE.OTHER]: 'Інше',
}

/**
 * Lead Type Codes (for conditional logic)
 */
export const LEAD_TYPE_CODE = {
  SELECTION: 'SELECTION',
  SALE: 'SALE',
  ALTERNATIVE_DEAL: 'ALTERNATIVE_DEAL',
  EVALUATION: 'EVALUATION',
  CONSULTATION: 'CONSULTATION',
  CONSULTATION_719: 'CONSULTATION_719',
  RENT: 'RENT',
  LEASE_OUT: 'LEASE_OUT',
  PARTNER_REQUEST: 'PARTNER_REQUEST',
  OTHER: 'OTHER',
}

/**
 * Client Type Codes (for conditional logic)
 */
export const CLIENT_TYPE_CODE = {
  STANDARD: 'STANDARD',
  EOSELIA: 'EOSELIA',
  DECREE_719: 'DECREE_719',
  FALLEN_FAMILY: 'FALLEN_FAMILY',
  INVESTOR: 'INVESTOR',
}

/**
 * Purchase Type Codes (for conditional logic)
 */
export const PURCHASE_TYPE_CODE = {
  CASH: 'CASH',
  EOSELIA: 'EOSELIA',
  COMPENSATION_719: 'COMPENSATION_719',
  INSTALLMENT: 'INSTALLMENT',
  MORTGAGE: 'MORTGAGE',
  OWN_FUNDS_PLUS_LOAN: 'OWN_FUNDS_PLUS_LOAN',
  EXCHANGE_NO_EXTRA: 'EXCHANGE_NO_EXTRA',
  EXCHANGE_WITH_EXTRA: 'EXCHANGE_WITH_EXTRA',
  UNDECIDED: 'UNDECIDED',
}

/**
 * Get all status options for select
 */
export const getStatusOptions = () => {
  return Object.values(LEAD_STATUS).map((status) => ({
    value: status,
    label: LEAD_STATUS_LABELS[status],
  }))
}

/**
 * Get all state options for select
 */
export const getStateOptions = () => {
  return Object.values(LEAD_STATE).map((state) => ({
    value: state,
    label: LEAD_STATE_LABELS[state],
  }))
}

/**
 * Get all source options for select
 */
export const getSourceOptions = () => {
  return Object.values(LEAD_SOURCE).map((source) => ({
    value: source,
    label: LEAD_SOURCE_LABELS[source],
  }))
}
